export default class CommonGetters {
  /**
   * Getters by ID
   */
  static getCountryById (countryID, countries) {
    let countryIndex = countries.findIndex(country => country.id === countryID);

    if (countryIndex > -1) {
      return countries[countryIndex].name;
    }

    return '-';
  }

  static getCurrencyById (currencyID, currencies) {
    let currencyIndex = currencies.findIndex(currency => currency.id === currencyID);

    if (currencyIndex > -1) {
      return currencies[currencyIndex].code;
    }

    return '-';
  }

  static getSourceById (sourceID, sources) {
    let sourceIndex = sources.findIndex(source => source.id === sourceID);

    if (sourceIndex > -1) {
      return sources[sourceIndex].name;
    }

    return '-';
  }

  /**
   * Getters for select fields
   */
  static getCountriesForSelect (countries) {
    return countries.map(country => ({
      id: country.id,
      iso_a3: country.iso_a3,
      text: country.name
    }));
  }

  static getAircraftsForSelect (aircrafts) {
    return aircrafts.map(aircraft => ({
      value: aircraft.id,
      text: aircraft.regin_mark
    }));
  }

  static getCustomersForSelect (customers) {
    return customers.map(customer => ({
      value: customer.id,
      text: customer.name
    }));
  }
}
